import { Card } from "antd";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels?: string[];
  onStepClick?: (step: number) => void;
}

const StepIndicator = ({ currentStep, totalSteps, labels, onStepClick }: StepIndicatorProps) => {
  return (
    <Card style={{ marginBottom: "16px", textAlign: "center" }} bodyStyle={{ padding: "12px" }}>
      <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
        {Array.from({ length: totalSteps }, (_, i) => {
          const isCompleted = currentStep > i;
          const isCurrent = currentStep === i;
          const isClickable = i <= currentStep && !!onStepClick;

          return (
            <div
              key={i}
              onClick={() => isClickable && onStepClick?.(i)}
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: isCurrent
                  ? "#66469c"
                  : isCompleted
                  ? "#9cc43c"
                  : "#f0f0f0",
                color: isCurrent || isCompleted ? "white" : "#666",
                fontWeight: "bold",
                fontSize: "14px",
                cursor: isClickable ? "pointer" : "default",
                transition: "all 0.2s ease",
                border: isClickable ? "2px solid transparent" : "2px solid #f0f0f0",
              }}
              onMouseEnter={(e) => {
                if (isClickable) {
                  e.currentTarget.style.transform = "scale(1.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (isClickable) {
                  e.currentTarget.style.transform = "scale(1)";
                }
              }}
              title={labels?.[i] || `${i + 1} žingsnis`}
            >
              {i + 1}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default StepIndicator;
